import { ComponentLoader } from '@bythepixel/component-loader';
import Accordion from '@Components/accordion';
import CategorySelector from '@Components/category-selector';
import CapabilityListController from '@Components/capability-list-controller';
import CollapsibleContent from '@Components/collapsible-content';
import Slider from '@Components/slider';
import FooterController from '@Components/footer-controller';
import FormController from '@Components/form-controller';
import ImageSpinner from '@Components/image-spinner';
import ColorSquareGrid from '@Components/color-square-grid';
import LoadMore from '@Components/load-more';
import InViewSrcset from '@Components/inViewSrcset';
import SocialShareModal from '@Components/social-share-modal';
import NavController from '@Components/nav-controller';
import AnimationController from '@Front/controllers/new-animation-controller';
import IntraLinkController from '@Front/controllers/intra-link-controller';
import ParallaxController from '@Front/controllers/parallax-controller';
import StickyContainer from '@Components/sticky-container';
import ModalController from '../components/modal-controller';
import SectionSliderController from '../sections/section-slider-controller';

const COMPONENTS = [
  Accordion,
  AnimationController,
  CapabilityListController,
  CategorySelector,
  ColorSquareGrid,
  CollapsibleContent,
  FooterController,
  FormController,
  ImageSpinner,
  InViewSrcset,
  LoadMore,
  ModalController,
  NavController,
  ParallaxController,
  SectionSliderController,
  Slider,
  SocialShareModal,
  StickyContainer,
];

// If we can, rely on native scroll padding to prevent our sticky nav
// from covering our intralink target post-scroll
if (!CSS.supports('scroll-margin-block: 1rem')) {
  COMPONENTS.push(IntraLinkController);
}

window.globalComponents = new ComponentLoader(document, COMPONENTS);
